import { Fragment, ReactElement, useRef, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface SetLayoutProps {
    children: ReactElement[] | ReactElement;
    setXWeb?: any;
    viewStyle?: any;
}

export const SetLayout: React.FC<SetLayoutProps> = ({
    children,
    setXWeb,
    viewStyle,
}): ReactElement => {
    const boxRef = useRef();

    // X

    // This function calculate X and Y
    const getPosition = () => {
        const x = boxRef && boxRef?.current && boxRef?.current?.offsetLeft;
        setXWeb && setXWeb(x);
    };

    // Get the position of the red box in the beginning
    useEffect(() => {
        boxRef && boxRef?.current && getPosition();
    }, []);

    // Re-calculate X and Y of the red box when the window is resized by the user
    useEffect(() => {
        window.addEventListener("resize", getPosition);
    }, []);

    return (
        <div className={"set-layout-container"}>
            <div className={"set-layout-view"} style={viewStyle} ref={boxRef}>
                <Fragment>
                    {children}
                    <ToastContainer />
                </Fragment>
            </div>
        </div>
    );
};
